import ProductBlacklistService, { IProductBlacklistEntry } from '@/services/banking/ProductBlacklistService';

const productBlacklistService = new ProductBlacklistService();

export const getAllEntries = async({ commit }: {commit: Function}) => {
    commit('isFetching', true);
    try {
        console.log('[productBlacklist/getAllEntries] Fetching entries...');
        const entries = await productBlacklistService.getAllEntries();
        console.log('[productBlacklist/getAllEntries] Received entries:', entries);
        commit('allEntries', entries);
    } catch (error) {
        console.error('[productBlacklist/getAllEntries] Error fetching entries:', error);
        commit('allEntries', []);
        throw error;
    } finally {
        commit('isFetching', false);
    }
}

export const getBlacklistedProductIds = async({ commit }: {commit: Function}) => {
    return await productBlacklistService.getBlacklistedProductIds();
}

export const getEntry = async({ commit }: {commit: Function}, prodId: string) => {
    return await productBlacklistService.getEntry(prodId);
}

export const getEntriesByOrg = async({ commit }: {commit: Function}, orgId: string) => {
    return await productBlacklistService.getEntriesByOrg(orgId);
}

export const createEntry = async({ commit }: {commit: Function}, entry: Omit<IProductBlacklistEntry, 'createdAt' | 'updatedAt'>) => {
    await productBlacklistService.createEntry(entry);
}

export const updateEntry = async({ commit }: {commit: Function}, payload: { prodId: string, updates: Partial<IProductBlacklistEntry> }) => {
    await productBlacklistService.updateEntry(payload.prodId, payload.updates);
}

export const deleteEntry = async({ commit }: {commit: Function}, prodId: string) => {
    await productBlacklistService.deleteEntry(prodId);
}
